// Bottom tab bar — primary navigation on phone + tablet (<1024), replacing the
// desktop sidebar. Destinations + order come from the pure navDestinations
// selector; this maps each id to its icon and renders a thumb-zone NavLink row.

import { NavLink } from 'react-router-dom';
import { navDestinations } from '@/view-models/navDestinations';
import { useNavGates } from '@/hooks/useNavGates';
import { NAV_ICONS } from './navIcons';
import { cn } from '@/lib/cn';

export function MobileTabBar() {
  const destinations = navDestinations(useNavGates());

  return (
    <nav
      className={cn(
        'shrink-0 flex items-stretch',
        'bg-[var(--bg-surface)] border-t border-[var(--border-subtle)]',
        // Respect the iOS home-indicator safe area.
        'pb-[env(safe-area-inset-bottom)]',
      )}
      aria-label="Primary"
    >
      {destinations.map(({ id, to, label }) => {
        const Icon = NAV_ICONS[id];
        return (
          <NavLink
            key={id}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors',
                isActive
                  ? 'text-[var(--fg-primary)]'
                  : 'text-[var(--fg-faint)] hover:text-[var(--fg-muted)]',
              )
            }
          >
            <Icon className="w-5 h-5" aria-hidden />
            {label}
          </NavLink>
        );
      })}
    </nav>
  );
}
